//@ts-nocheck
import React, { useState } from "react";
import {
    Box,
    Modal,
    Button,
    TextField,
    IconButton,
    Typography,
    Stack,
    useMediaQuery,
    useTheme,
    Checkbox,
    FormControlLabel,
    Tabs,
    Tab
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useSetSnackBar } from "../../store/Snackbar.state";
import { useMerchantBlackListCheck } from "../../hooks";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import 'dayjs/locale/tr';
import dayjs from "dayjs";
import ClearIcon from '@mui/icons-material/Clear';
import RestartAltIcon from '@mui/icons-material/RestartAlt';

interface Props {
    isOpen: boolean;
    handleClose: () => void;
}

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

const TabPanel = (props: TabPanelProps) => {
    const { children, value, index, ...other } = props;
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            {...other}
        >
            {value === index && (
                <Box sx={{ pt: 3 }}>
                    {children}
                </Box>
            )}
        </div>
    );
};

export const MerchantBlackListCheckModal: React.FC<Props> = ({ isOpen, handleClose }) => {
    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
    const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

    const [merchantName, setMerchantName] = useState<string>("");
    const [taxNumber, setTaxNumber] = useState<string>("");
    const [tabValue, setTabValue] = useState(0);
    const [firstName, setFirstName] = useState<string>("");
    const [lastName, setLastName] = useState<string>("");
    const [identityNumber, setIdentityNumber] = useState<string>("");
    const [birthDate, setBirthDate] = useState<dayjs.Dayjs | null>(null);

    const setSnackbar = useSetSnackBar();
    const { mutate: checkMerchantBlackList, isLoading } = useMerchantBlackListCheck();

    const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
        setTabValue(newValue);
    };

    const resetCompanyFields = () => {
        setMerchantName("");
        setTaxNumber("");
    };

    const resetPersonFields = () => {
        setFirstName("");
        setLastName("");
        setIdentityNumber("");
        setBirthDate(null);
    };

    const handleClearAll = () => {
        resetCompanyFields();
        resetPersonFields();
    };

    const handleSubmit = () => {
        if (tabValue === 0 && (!merchantName || !taxNumber)) {
            setSnackbar({
                severity: "error",
                description: "Lütfen firma bilgilerini doldurunuz",
                isOpen: true,
            });
            return;
        }

        if (tabValue === 1 && (!firstName || !lastName || !identityNumber || !birthDate)) {
            setSnackbar({
                severity: "error",
                description: "Lütfen yetkili kişi bilgilerini doldurunuz",
                isOpen: true,
            });
            return;
        }

        checkMerchantBlackList(
            {
                ...(tabValue === 0 ? {
                    merchantName,
                    taxNumber,
                } : {
                    firstName,
                    lastName,
                    identityNumber,
                    birthDate: birthDate?.format('YYYY-MM-DD')
                })
            },
            {
                onSuccess: (response) => {
                    if (response.isSuccess) {
                        setSnackbar({
                            severity: "success",
                            description: response.data.message,
                            isOpen: true,
                        });
                    } else {
                        setSnackbar({
                            severity: "error",
                            description: response.data.message,
                            isOpen: true,
                        });
                    }
                },
                onError: () => {
                    setSnackbar({
                        severity: "error",
                        description: "İşlem sırasında bir hata oluştu",
                        isOpen: true,
                    });
                },
            }
        );
    };

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="tr">
            <Modal
                open={isOpen}
                onClose={handleClose}
                aria-labelledby="merchant-blacklist-check-modal"
            >
                <Box
                    sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        width: isDesktop ? 800 : isSmallScreen ? "90%" : "70%",
                        bgcolor: "background.paper",
                        border: "2px solid #2196f3",
                        boxShadow: 24,
                        p: 4,
                        borderRadius: 2,
                    }}
                >
                    <Typography variant="h6" component="h2" mb={3}>
                        Kara Liste Kontrol
                    </Typography>

                    <Tabs
                        value={tabValue}
                        onChange={handleTabChange}
                        variant="fullWidth"
                        sx={{ borderBottom: 1, borderColor: 'divider' }}
                    >
                        <Tab label="Firma Bilgileri" />
                        <Tab label="Yetkili Kişi Bilgileri" />
                    </Tabs>

                    <TabPanel value={tabValue} index={0}>
                        <Stack spacing={3}>
                            <TextField
                                fullWidth
                                label="Firma Adı"
                                value={merchantName}
                                onChange={(e) => setMerchantName(e.target.value)}
                                placeholder="Firma adını giriniz"
                            />
                            <TextField
                                fullWidth
                                label="Vergi Numarası"
                                value={taxNumber}
                                onChange={(e) => setTaxNumber(e.target.value)}
                                placeholder="Vergi numarasını giriniz"
                            />
                        </Stack>
                    </TabPanel>

                    <TabPanel value={tabValue} index={1}>
                        <Stack spacing={3}>
                            <TextField
                                fullWidth
                                label="Ad"
                                value={firstName}
                                onChange={(e) => setFirstName(e.target.value)}
                                placeholder="Yetkili kişinin adını giriniz"
                            />
                            <TextField
                                fullWidth
                                label="Soyad"
                                value={lastName}
                                onChange={(e) => setLastName(e.target.value)}
                                placeholder="Yetkili kişinin soyadını giriniz"
                            />
                            <TextField
                                fullWidth
                                label="TC Kimlik No"
                                value={identityNumber}
                                onChange={(e) => setIdentityNumber(e.target.value)}
                                placeholder="TC Kimlik numarasını giriniz"
                                inputProps={{ maxLength: 11 }}
                            />
                            <DatePicker
                                label="Doğum Tarihi"
                                value={birthDate}
                                onChange={(newValue) => setBirthDate(newValue)}
                                format="DD.MM.YYYY"
                                slotProps={{
                                    textField: {
                                        fullWidth: true,
                                        placeholder: "GG.AA.YYYY"
                                    }
                                }}
                            />
                        </Stack>
                    </TabPanel>

                    <Box sx={{ mt: 3, display: 'flex', gap: 2 }}>
                        <Button
                            fullWidth
                            variant="outlined"
                            onClick={handleClearAll}
                            disabled={isLoading}
                            startIcon={<RestartAltIcon />}
                            sx={{
                                borderColor: "#2196f3",
                                color: "#2196f3",
                                "&:hover": {
                                    borderColor: "#1976d2",
                                    bgcolor: "rgba(33, 150, 243, 0.04)",
                                },
                            }}
                        >
                            Temizle
                        </Button>
                        <Button
                            fullWidth
                            variant="contained"
                            onClick={handleSubmit}
                            disabled={isLoading}
                            sx={{
                                bgcolor: "#2196f3",
                                "&:hover": {
                                    bgcolor: "#1976d2",
                                },
                            }}
                        >
                            {isLoading ? "Kontrol Ediliyor..." : "Kontrol Et"}
                        </Button>
                    </Box>

                    <IconButton
                        sx={{
                            position: "absolute",
                            top: 8,
                            right: 8,
                        }}
                        onClick={handleClose}
                    >
                        <CloseIcon />
                    </IconButton>
                </Box>
            </Modal>
        </LocalizationProvider>
    );
};